/*
  Cheer AjaxForm
  version 1.2.0

  subport
  sweetalert2

  < 2021-03-15 - ปรับ loading (ajaxView) ให้ใช้ class ของ bootstrap 4
      - เพิ่ม setBtnTextAfterSubmitSuccess สำหรับเปลี่ยนข้อความในปุ่มหลัง submit
      - เพิ่ม submitDone.showCancelButton สำหรับแสดงปุ่มยกเลิกหลัง submit สำเร็จ
  2021-03-15 - เพิ่มปุ่ม submit มีได้มากกว่า 1 ปุ่ม
*/

(function ( $ ) {

    //ajaxSubmit
    $.fn.ajaxSubmit = function(options) {
        var opts = $.extend(true, {}, $.fn.ajaxSubmit.defaults, options );
        var submit_status = 1;
        var _this = this;

        this.on('click', '.btn-submit', function(e) {
            _this.find('.btn-submit').attr('clicked', 'false');
            $(this).attr('clicked', 'true');
        });

        this.on('submit', async function(e){
          e.preventDefault();
          if(!await opts.permission()) {
              return false;
          }

          if(submit_status++ !== 1){return false;}
          let _this = this;
          var btnSubmit = $(_this).find('.btn-submit[clicked="true"]');
          var btnTextSubmit = btnSubmit.find('.txt-saving').text();

          opts.loadForm( 'loader', btnSubmit, btnTextSubmit, opts.classLoader );
          opts.beforeSubmit();

          var ajaxSetup = {
            method: $(_this).attr('method'),
            url: _this.action,
            data: new FormData(_this),
          };

          $.extend( true, ajaxSetup, opts.ajaxSetup );

          ajaxSetup = setMethod(ajaxSetup);

          $.ajax(ajaxSetup)
            .done(function(data){
              if (data.hasOwnProperty('success')) {
                if(opts.clearForm) {
                  opts.clearForm.clearFn(opts.clearForm.clearID);
                }
                else {
                  if(opts.formUpdate) {
                    opts.SetFormUpdate.formSet.action = opts.SetFormUpdate.formSet.action.replace(':id', data.id);
                    opts.SetFormUpdate.SetFormFn(_this, opts.SetFormUpdate.formSet);
                  }
                }

                if(opts.setBtnTextAfterSubmitSuccess) {
                  btnTextSubmit = opts.setBtnTextAfterSubmitSuccess;
                }

                if(opts.swalAlert) {
                  swal({
                    type: 'success',
                    title: opts.swalTitle,
                    html: opts.submitDone.html,
                    confirmButtonText: opts.submitDone.confirmButtonText,
                    showCancelButton: opts.submitDone.showCancelButton,
                  }).then((result) => {
                    if (result.value) {
                      opts.afterSubmitSuccessConfirm(data);
                    }
                  });
                }

                opts.afterSubmitSuccess(data);

                if(opts.dataTable) {
                  opts.dataTable.ajax.reload( null, false );
                }
              }
              else if(data.hasOwnProperty('error')) {
                  swal({
                      type: 'warning',
                      title: opts.swalTitle,
                      text: opts.submitWarning.text,
                      confirmButtonText: opts.submitWarning.confirmButtonText,
                  }).then((result) => {
                      if (result.value) {

                      }
                  });

                  opts.validateAlert(data.error, opts.showErrorOther);

                  opts.afterSubmitError(data);
              }
              else if(data.hasOwnProperty('errorMsg')) {
                  swal({
                      type: 'warning',
                      title: opts.swalTitle,
                      html: data.errorMsg,
                      confirmButtonText: opts.submitWarning.confirmButtonText,
                  });
                  opts.afterSubmitError(data);
              }

              opts.afterSubmit(data);
            })
            .fail(function(){
              opts.afterSubmitFail();
              swal(
                opts.swalTitle,
                opts.submitFail.text,
                'error'
              );
            })
            .always(function() {
              submit_status = 1;
              opts.loadForm( 'unload', btnSubmit, btnTextSubmit, opts.classLoader );
              opts.afterSubmitAlways();
            });

          return false;
        });
        return this;
    };

    $.fn.ajaxSubmit.loadForm = function( action, btnSubmit, btnTextSubmit, classLoader ) {
      if(action === 'loader') {
        btnSubmit.find('.load-anime').addClass(classLoader);
        btnSubmit.find('.txt-saving').text('กำลัง'+btnTextSubmit);
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback, .invalid-tooltip').text('');
        $('.invalid-box').hide().html('');
        return btnSubmit;
      }
      else {
        btnSubmit.find('.load-anime').removeClass(classLoader);
        btnSubmit.find('.txt-saving').text(btnTextSubmit);
      }
    };

    $.fn.ajaxSubmit.validateAlert = function( dataError, showErrorOther) {
        var otherShow = {};
        $.each( dataError, function( key, value ) {
          key = key.split('.');
          if($.inArray(key[0], showErrorOther.list) >= 0) {
            if(otherShow[key[0]]) { } else { otherShow[key[0]] = []; }
            otherShow[key[0]].push(key[1] ? 'ตัวที่ '+key[1]+' '+value[0] : value[0]);
          }
          else {
            if(key.length > 1){
              key = key[0]+'['+key[1]+']';
            } else {
              key = key[0];
            }
            $('.form-control[name="'+key+'"]').addClass('is-invalid').nextAll('.invalid-feedback, .invalid-tooltip').text(value[0]);
          }
        });

        $.each( showErrorOther.list, function( key, value ) {
          if(otherShow[value]) {
            if(showErrorOther.fnShow[key]) {
              showErrorOther.fnShow[key](otherShow[value], showErrorOther.selector[key]);
            }
            else {
              $.fn.ajaxSubmit.showErrorOther(otherShow[value], showErrorOther.selector[key]);
            }
          }
        });
    };

    $.fn.ajaxSubmit.showErrorOther = function( dataError, selector = null) {
      if(selector) {
        selector.addClass('is-invalid');
        selector.next('.invalid-box').fadeIn();
        $.each( dataError, function( key, value ) {
          selector.nextAll('.invalid-box').append(value+'<br>');
        });
      }
    };

    $.fn.ajaxSubmit.defaults = {
        dataTable: false,
        swalAlert: true,
        swalTitle: 'การบันทึก',
        submitDone: {
          html: 'เสร็จสิ้นเรียบร้อยแล้ว',
          confirmButtonText: 'ตกลง',
          showCancelButton: false
        },
        submitWarning: {
          text: 'กรุณาตรวจสอบข้อมูล',
          confirmButtonText: 'ตกลง'
        },
        submitFail: {
          text: 'ผิดพลาด'
        },
        permission: function(){ return true; },
        beforeSubmit: function(){},
        afterSubmit: function(){},
        afterSubmitSuccess: function(){},
        afterSubmitError: function(){},
        afterSubmitFail: function(){},
        afterSubmitAlways: function(){},
        afterSubmitSuccessConfirm: function(){},
        ajaxSetup: {
          cache: false,
          contentType: false,
          processData: false
        },
        loadForm: $.fn.ajaxSubmit.loadForm,
        classLoader: 'spinner-border spinner-border-sm',
        validateAlert: $.fn.ajaxSubmit.validateAlert,
        showErrorOther: {list: {}, selector: {}, fnShow: {}},
        clearForm: {
          clearID: '#clear',
          clearFn: function(clearID){
            $(clearID).trigger('click');
          },
        },
        formUpdate: false,
        SetFormUpdate: {
            formSet: {'action': null, 'method': 'PUT'},
            SetFormFn: function(form, formSet) {
              $(form).attr(formSet);
          },
        },
        setBtnTextAfterSubmitSuccess: false,
    };
    //ajaxSubmit

    //ajaxClearForm
    $.fn.ajaxClearForm = function(options) {
      var opts = $.extend(true, {}, $.fn.ajaxClearForm.defaults, options );
      this.on('click', function(e) {
        e.preventDefault();
        opts.clearForm(this, opts.formSetStore, opts.actionForm);
        opts.afterClear();
      });
    };

    $.fn.ajaxClearForm.clearForm = function( elm, formSetStore, actionForm ) {
        var form = formSetStore.formID ? $(formSetStore.formID) : $(elm).closest('form');
        if(actionForm) {
          form.attr(formSetStore.ajaxSet);
        }
        form.find('input, textarea, select').not('.not-clear,:radio, :checkbox').val('');
        form.find('input:checkbox, input:radio').not('.not-clear').prop("checked", false);
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback, .invalid-tooltip').text('');
        $('.invalid-box').hide().html('');
    };

    $.fn.ajaxClearForm.defaults = {
        clearForm: $.fn.ajaxClearForm.clearForm,
        formSetStore: {
          ajaxSet: {'action': null, 'method': 'POST'},
          formID: '#form-submit',
        },
        actionForm: true,
        afterClear: function(){},
    };
    //ajaxClearForm

    //ajaxView
    $.fn.ajaxView = function(options) {
      var opts = $.extend( true, {}, $.fn.ajaxView.defaults, options );
      this.closest('.dataTables_wrapper').on('click', opts.classLink, function(e) {

        e.preventDefault();
        var _this = this;

        opts.loader(_this, opts.classLoad, 'loader', opts.classSpinner);
        opts.beforeSubmit();

        var ajaxSetup = {
          url: _this.href
        };
        $.extend( true, ajaxSetup, opts.ajaxSetup );
        ajaxSetup = setMethod(ajaxSetup);

        $.ajax(ajaxSetup)
        .done(function(data){
          if(data.hasOwnProperty('data')) {
            opts.afterSubmitSuccess(_this, data);

            opts.clearForm.clearFn(opts.clearForm.clearID);
            opts.setForm(data, _this);

            if (opts.formSetUpdate) {
                $(opts.formSetUpdate.formID).attr({
                  'action': opts.formSetUpdate.ajaxSet.action.replace(':id', data.data.id),
                  'method': opts.formSetUpdate.ajaxSet.method
                });
            }
          }
          opts.afterSubmit();
        })
        .always(function(){
          opts.loader(_this, opts.classLoad, 'unload', opts.classSpinner);
          opts.afterSubmitAlways();
        });
      });
    };

    $.fn.ajaxView.loader = function( elm, classLoad, action = 'unload', classSpinner ) {
      if(action === 'loader') {
        $(elm).prev(classLoad).addClass(classSpinner);
      }
      else {
        $(elm).prev(classLoad).removeClass(classSpinner);
      }
    };

    $.fn.ajaxView.defaults = {
        classLink: '.view-data',
        classLoad: '.load-view',
        classSpinner: 'spinner-border spinner-border-sm mr-1',
        loader: $.fn.ajaxView.loader,
        ajaxSetup: {method: 'GET'},
        beforeSubmit: function(){},
        afterSubmitSuccess: function(elem, data){},
        afterSubmit: function(){},
        afterSubmitAlways: function(){},
        setForm: function(data){},
        formSetUpdate: {
          ajaxSet: {'action': null, 'method': 'PUT'},
          formID: '#form-submit',
        },
        clearForm: {
          clearID: '#clear',
          clearFn: function(clearID) {
            $(clearID).trigger('click');
          },
        },
    };
    //ajaxView

    //ajax
    var ajaxFn_submit_status = 1;
    $.ajaxFn = function (options) {
      var opts = $.extend( true, {}, $.ajaxFn.defaults, options );

      if(ajaxFn_submit_status++ !== 1) {
          if(opts.waiting) {
              return false;
          }
      }

      opts.beforeSubmit();

      opts.ajaxSetup = setMethod(opts.ajaxSetup);

      $.ajax(opts.ajaxSetup)
        .done(function(data){
          if (data.hasOwnProperty('success')) {
            if(opts.swalAlert) {
              swal({
                type: 'success',
                title: opts.swalTitle,
                text: opts.submitDone.text,
                confirmButtonText: opts.submitDone.confirmButtonText,
              });
            }
            opts.afterSubmitSuccess(data);
          }
          else if(data.hasOwnProperty('error')){
            if(opts.swalAlert) {
              swal({
                type: 'warning',
                title: opts.swalTitle,
                text: opts.submitWarning.text,
                confirmButtonText: opts.submitWarning.confirmButtonText,
              });
            }
            opts.afterSubmitError(data);
          }
          opts.afterSubmit(data);
        })
        .fail(function(){
          opts.afterSubmitFail();
          if(opts.swalAlert) {
            swal(
              opts.swalTitle,
              opts.submitFail.text,
              'error'
            );
          }
        })
        .always(function() {
          ajaxFn_submit_status = 1;
          opts.afterSubmitAlways();
        });
    }
    $.ajaxFn.defaults = {
      ajaxSetup: {
        url: null,
        data: {},
        method: 'POST',
      },
      waiting: true,
      swalAlert: true,
      swalTitle: 'การบันทึก',
      submitDone: {
        text: 'เสร็จสิ้นเรียบร้อยแล้ว',
        confirmButtonText: 'ตกลง'
      },
      submitWarning: {
        text: 'กรุณาตรวจสอบข้อมูล',
        confirmButtonText: 'ตกลง'
      },
      submitFail: {
        text: 'ผิดพลาด'
      },
      beforeSubmit: function(){},
      afterSubmit: function(){},
      afterSubmitSuccess: function(){},
      afterSubmitError: function(){},
      afterSubmitFail: function(){},
      afterSubmitAlways: function(){},
    }
    //ajax

    function setMethod(ajaxSetup)
    {
      ajaxSetup.method = ajaxSetup.method.toUpperCase();
      if($.inArray(ajaxSetup.method, ['POST', 'GET']) === -1) {
        switch(ajaxSetup.data.constructor) {
          case FormData:
              ajaxSetup.data.append('_method', ajaxSetup.method);
              break;
          case Object:
          case Array:
              $.extend( true, ajaxSetup.data, {'_method': ajaxSetup.method} );
              break;
          default:
              ajaxSetup.data += '&_method='+ajaxSetup.method
        };
        ajaxSetup.method = 'POST';
      }
      return ajaxSetup;
    }

}( jQuery ));
